import BrieIconOutlinedSrc from "assets/img/icons/common/icon_Brie_outlined.svg";

const BrieIconOutlined = ({ transform }: { transform?: string }) => {
  return (
    <img
      src={BrieIconOutlinedSrc}
      style={{
        transform: transform ? transform : undefined,
        paddingLeft: 1,
        paddingRight: 2,
        paddingTop: 5,
        paddingBottom: 5,
      }}
      alt="ICON"
    ></img>
  );
};

export default BrieIconOutlined;
